import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Student } from '../interfaces/student';

export interface StudentRegistrationPayload {
  name: string;
  lastname: string;
  ci: string;
  email: string;
  idcareer: number;
  status?: number;
  password?: string;
}

@Injectable({
  providedIn: 'root'
})
export class StudentService {
  private myAppUrl: string;
  private myApiUrl: string;

  constructor(private http: HttpClient) {
    this.myAppUrl = environment.endpoint;
    this.myApiUrl = 'api/students/';
  }

  getListStudents(): Observable<Student[]> {
    return this.http.get<Student[]>(`${this.myAppUrl}${this.myApiUrl}`);
  }

  deleteStudent(id: number): Observable<void> {
    return this.http.delete<void>(`${this.myAppUrl}${this.myApiUrl}${id}`);
  }

  deleteStudentRegistration(id: number): Observable<void> {
    return this.http.delete<void>(`${this.myAppUrl}${this.myApiUrl}registration/${id}`);
  }

  saveStudent(student: Student): Observable<void> {
    return this.http.post<void>(`${this.myAppUrl}${this.myApiUrl}`, student);
  }

  registerStudentWithCareer(payload: StudentRegistrationPayload): Observable<any> {
    return this.http.post(`${this.myAppUrl}${this.myApiUrl}registration`, payload);
  }

  getStudent(id: number): Observable<Student> {
    return this.http.get<Student>(`${this.myAppUrl}${this.myApiUrl}${id}`);
  }

  getStudentByUserId(userid: string): Observable<Student> {
    return this.http.get<Student>(`${this.myAppUrl}${this.myApiUrl}by-user/${userid}`);
  }

  updateStudent(id: number, student: Student): Observable<void> {
    return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}${id}`, student);
  }

  updateStudentRegistration(id: number, payload: StudentRegistrationPayload): Observable<void> {
    return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}registration/${id}`, payload);
  }

  updateStudentStatus(id: number, status: number): Observable<void> {
    return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}${id}/status`, { status });
  }

  disableAllStudents(): Observable<void> {
    return this.http.put<void>(`${this.myAppUrl}${this.myApiUrl}disable-all`, {});
  }
}
